import { min } from "date-fns";
import { CMSPath, DEV_IP, INROOMTAB } from "../../config/constant";

export function save_in_temp(filename, dataObj, successCallback, errorCallback){

    window.requestFileSystem(window.LocalFileSystem.TEMPORARY, 0, function (fs) {

        console.log('file system open: ' + fs.name);
        fs.root.getFile(filename, { create: true, exclusive: false }, function (fileEntry) {
    
            console.log("fileEntry is file?" + fileEntry.isFile.toString());
            // fileEntry.name == 'someFile.txt'
            // fileEntry.fullPath == '/someFile.txt'
            writeFile(fileEntry, dataObj, successCallback, errorCallback);
    
        }, errorCallback);
    
    }, errorCallback);
}
export function formatMinutesToHHMMSS(minutes) {
    const hours = String(Math.floor(minutes / 60)).padStart(2, '0');   
    const mins = String(minutes % 60).padStart(2, '0');
    return `${hours}:${mins}:00`;
}

export function formatMinutesToTimeFormat(minutes, is12hourFormat) {
    if (minutes >= 60 * 24) return  ;

    let hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    let suffix = "";

    if (is12hourFormat) {
        if (hours >= 12) {
            suffix = "PM";
            if (hours > 12) {
                hours -= 12;
            }
        } else {
            suffix = "AM";
            if (hours === 0) {
                hours = 12;
            }
        }
    }

    return `${hours}:${mins.toString().padStart(2, '0')} ${suffix}`.trim();
}

export function save_in_persistent(filename, dataObj, successCallback){

    if(window.cordova){
    window.requestFileSystem(window.LocalFileSystem.PERSISTENT, 0, function (fs) {

        console.log('file system open: ' + fs.name);
        fs.root.getFile(filename, { create: true, exclusive: false }, function (fileEntry) {
    
            console.log("fileEntry is file?" + fileEntry.isFile.toString());
            // fileEntry.name == 'someFile.txt'
            // fileEntry.fullPath == '/someFile.txt'
            writeFile(fileEntry, dataObj, successCallback);
    
        }, onErrorCreateFile);
    
    }, onErrorLoadFs);
    }
}

function writeFile(fileEntry, dataObj, successCallback, errorCallback) {
    // Create a FileWriter object for our FileEntry (log.txt).
    fileEntry.createWriter(function (fileWriter) {

        fileWriter.onwriteend = function() {
            console.log("Successful file write...");
            // readFile(fileEntry);
            successCallback(fileEntry.toURL());
        };

        fileWriter.onerror = function (e) {
            console.log("Failed file write: " + e.toString());
            errorCallback(e);
        };

        // If data object is not passed in,
        // create a new Blob instead.
        if (!dataObj) {
            dataObj = new Blob(['some file data'], { type: 'text/plain' });
        }

        fileWriter.write(dataObj);
        
    });
}

export function copy_to_tempstorage_if_exists(filename, successCallback, errorCallback){

    loadImageFromFile(filename, (blob) => save_in_temp(filename, blob, successCallback, errorCallback), errorCallback)
}

export function readFile(fileEntry, successCallback) {

    fileEntry.file(function (file) {
        var reader = new FileReader();

        reader.onloadend = function() {
            console.log("Successful file read: " + this.result);
            var blob = new Blob([new Uint8Array(this.result)], { type: file.type });
            // displayFileData(fileEntry.fullPath + ": " + this.result);
            successCallback(blob);
        };

        reader.readAsArrayBuffer(file);

    }, onErrorReadFile);
}


export function readFileFromUri(uri, successCallback) {
    const readBinaryFile = (fileEntry) => {
      fileEntry.file(function (file) {
          var reader = new FileReader();
          reader.onloadend = function() {
              var blob = new Blob([new Uint8Array(this.result)], { type: file.type });
              successCallback(blob);
          };
          reader.readAsArrayBuffer(file);
      }, onErrorReadFile);
    }

    if(window.cordova) window.resolveLocalFileSystemURL(uri, readBinaryFile, onErrorLoadFs)
}

export function getImageURL(filename, successCallback){
    window.requestFileSystem(window.LocalFileSystem.PERSISTENT, 0, function (fs) {

        console.log('file system open for URL read: ' + fs.name);
        fs.root.getFile(filename, { create: false, exclusive: false }, function (fileEntry) {
            
            console.log("fileEntry for URL is file?" + fileEntry.isFile.toString());
            successCallback(fileEntry.toURL());
    
        }, onErrorCreateFile);
    
    }, onErrorLoadFs);
}

export function getImageDataURL(filename, successCallback){
    window.requestFileSystem(window.LocalFileSystem.PERSISTENT, 0, function (fs) {

        console.log('file system open for URL read: ' + fs.name);
        fs.root.getFile(filename, { create: false, exclusive: false }, function (fileEntry) {
            
            console.log("fileEntry for URL is file?" + fileEntry.isFile.toString());

            fileEntry.file(function (file) {
                var reader = new FileReader();
      
                reader.onloadend = function() {
                    successCallback(this.result);
                };
                reader.readAsDataURL(file);
            }, onErrorLoadFs);

            // successCallback(fileEntry.toURL());
    
        }, onErrorCreateFile);
    
    }, onErrorLoadFs);
}

export function loadImageFromFile(filename, successCallback, errorCallback=null) {
    window.requestFileSystem(window.LocalFileSystem.PERSISTENT, 0, function (fs) {

        console.log('file system open for URL read: ' + fs.name);
        fs.root.getFile(filename, { create: false, exclusive: false }, function (fileEntry) {
        fileEntry.file(function (file) {
            var reader = new FileReader();
            reader.onloadend = function() {
                if (this.result) {
                    //var elem = document.getElementById("imageitem");
                    var blob = new Blob([new Uint8Array(this.result)], { type: "image/jpg" });
                    // successCallback(window.URL.createObjectURL(blob));
                    successCallback(blob);
                }
            };
            reader.readAsArrayBuffer(file);
        });
    }, errorCallback);
}, errorCallback);
}


export function setProfilePhotoObjectURL(filename, localStorageKey, errorCallback) {
    window.requestFileSystem(window.LocalFileSystem.PERSISTENT, 0, function (fs) {

        console.log('file system open for URL read: ' + fs.name);
        fs.root.getFile(filename, { create: false, exclusive: false }, function (fileEntry) {
        fileEntry.file(function (file) {
            var reader = new FileReader();
            reader.onloadend = function() {
                if (this.result) {
                    //var elem = document.getElementById("imageitem");
                    var blob = new Blob([new Uint8Array(this.result)], { type: "image/jpg" });
                    localStorage.setItem(localStorageKey, window.URL.createObjectURL(blob));
                }
            };
            reader.readAsArrayBuffer(file);
        });
    }, errorCallback);
}, errorCallback);
}


function onErrorCreateFile(err){
    console.log(`Error while creating file: ${err}`)
}

function onErrorLoadFs(err){
    console.log(`Error while loading file: ${err}`)
}

function onErrorReadFile(err){
    console.log(`Error while reading file: ${err}`)
}

export const getConnectionType = () => {
    console.log('get connection type called');
    if(navigator.connection){
        console.log('navigator.connection.type', navigator.connection.type);
        return navigator.connection.type;
    }
}

export const checkIfImageExists = (url, compRef, callback) => {
    const img = new Image();
    img.src = url //"https://cordova.apache.org/static/img/cordova-logo-newbrand.svg";

    console.log('URL******', url)
    
    if (img.complete) {
          console.log('found complete called')
          callback(true, compRef);
    } else {
        img.onload = () => {
          console.log('onload called')
          callback(true, compRef);
        };
        img.onerror = () => {
            if(window.FirebasePlugin){
                window.FirebasePlugin.logError("Image OnError called for mobile tv")
              }
            callback(false, compRef);
        }
    }
  }


  export const booleanConditionCheck = (value) => {

    if(typeof value == 'string'){
        switch(value){
            case "true": return true;
                break;
            case "false": return false;
                break;
        }
    } else if(typeof value == 'boolean'){
        switch(value){
            case true: return true;
                break;
            case false: return false;
                break;
        }
    }

  }


export const extractIdsOfStoreData = (searchId, data, filterFieldName, searchingFieldName) => {

    var filteredArray = data.filter((el) => el[searchingFieldName].id == searchId);
    let idArray = []
    for(let i=0; i<filteredArray.length; i++) idArray.push(filteredArray[i][filterFieldName].id)

    console.log('idArray', filterFieldName, searchingFieldName, idArray, data, searchId)
    return idArray
}

export const extractIdsOfSubtypeData = (searchId, data, filterFieldName, searchingFieldName) => {

    var filteredArray = data.filter((el) => el[searchingFieldName] == searchId);
    let idArray = []
    for(let i=0; i<filteredArray.length; i++) idArray.push(filteredArray[i][filterFieldName])

    console.log('idArray', filterFieldName, searchingFieldName, idArray, data, searchId)
    return idArray
}

export const  calculateTimeDifference = (date1, date2, unit = 'second') =>  {
    console.log("date1, date2, unit",date1, date2, unit)
    var difference = date2.getTime() - date1.getTime();

    var daysDifference = Math.floor(difference/1000/60/60/24);
    difference -= daysDifference*1000*60*60*24

    var hoursDifference = Math.floor(difference/1000/60/60);
    difference -= hoursDifference*1000*60*60

    var minutesDifference = Math.floor(difference/1000/60);
    difference -= minutesDifference*1000*60

    var secondsDifference = Math.floor(difference/1000);

    if(unit == 'second') return secondsDifference;
    else if(unit == 'minute') return minutesDifference;
    else if(unit == 'hour') return hoursDifference;
    else if(unit == 'day') return daysDifference;

    // console.log('difference = ' + 
    //   daysDifference + ' day/s ' + 
    //   hoursDifference + ' hour/s ' + 
    //   minutesDifference + ' minute/s ' + 
    //   secondsDifference + ' second/s ');
}


export const getDefaultAnalyticsLabel = (args) => {
    return {
        "appVersion": args.appVersion,
        "Room": localStorage.getItem("room") || "",
        "sourceApp": "guestJourneyApp",
        "layoutId": localStorage.getItem("currentDuration")
    }
}

export const generateToken = (widgetName) => {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return (widgetName || 'checkin_') + Math.random().toString(36).substr(2, 9);
  };

export const validateEmail = (email) => {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

export const toBool = (param) => {
    if(!param || param == "false" || param == "FALSE"){
        return false;
    } else {
        return true;
    }
}

export const formatTime = (date, timeFormat12hrs, gmtOffset) => {

    const utcTime = new Date(date);
    
    const offsetHours = gmtOffset ? gmtOffset.hours : 0;
    const offsetMinutes = gmtOffset ? gmtOffset.minutes : 0;
    
    utcTime.setHours(utcTime.getHours() + offsetHours);
    utcTime.setMinutes(utcTime.getMinutes() + offsetMinutes);

    let getTime;

    if(timeFormat12hrs !== null || timeFormat12hrs !== undefined) getTime = utcTime.toLocaleTimeString('en-US',{timeZone:'UTC', hour12:timeFormat12hrs , hour:'numeric',minute:'numeric'})
    else  getTime = utcTime.toLocaleTimeString('en-US',{timeZone:'UTC', hour12:true , hour:'numeric',minute:'numeric'})

    return getTime;
}

export const formatLocalTime = (date, timeFormat12hrs) => {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    let suffix = '';

    if (timeFormat12hrs) {
        suffix = hours >= 12 ? ' PM' : ' AM';
        hours = hours % 12 || 12;
    }

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}${suffix}`;
}

export const getCurrentGuestDetails = (list) => {
    let guestToken = localStorage.getItem("guestToken")
    let accompanyGuestId = localStorage.getItem("accompanyGuestId");
    let guest = []

    if(INROOMTAB){
        guest.push(list[0]);
    } else {
    list.forEach(o => {
        if (o.guestToken == guestToken) {
            if (accompanyGuestId && o.accompanyGuestList) {
                const accompanyGuestDetails = o.accompanyGuestList.find(details => details.id == accompanyGuestId);
                if (accompanyGuestDetails) {
                    o.guestProfile = accompanyGuestDetails;
                    o.guestName = accompanyGuestDetails.guestFullName || `${accompanyGuestDetails.firstName} ${accompanyGuestDetails.lastName}`;
                }
            }
            guest.push(o);
        }
    });
    }

    console.log("checkin guest info", guest)

    return guest;
}

export const renderPDFFile = (URL, pdfFileName, setLoader, setFailScreen, callback) => {
    window.requestFileSystem(window.LocalFileSystem.PERSISTENT, 0, function (fs) {

        console.log('file system open: ' + fs.name);
        fs.root.getFile(`${pdfFileName}`, { create: true, exclusive: false }, function (fileEntry) {
    
            console.log("fileEntry is file? " + JSON.stringify(fileEntry));

            var fileTransfer = new window.FileTransfer();
            fileEntry.remove();
            
            var uri = encodeURI(`http://${DEV_IP}:8080/cmsData/hotelInfo/files/food_menu.pdf`);

            let filePath = window.cordova.file.externalDataDirectory + `${pdfFileName}`
            console.log("File directory", filePath)
            fileTransfer.download(
                `${URL}`,
                filePath,
                function(entry) {
                    let url = entry.toURL()
                    console.log("download complete: " + url);


                    // window.cordova.plugins.fileOpener2.appIsInstalled('com.google.android.apps.docs', {
                    //     success : function(res) {
                    //         if (res.status === 0) {
                    //             // show popup to download the app
                    //             console.log('G-Drive is not installed.');
                    //         } else {
                                window.cordova.plugins.fileOpener2.open(
                                    url, // You can also use a Cordova-style file uri: cdvfile://localhost/persistent/Downloads/starwars.pdf
                                    'application/pdf',
                                    {
                                        error : function(e) {
                                            console.log('Error status: ' + e.status + ' - Error message: ' + e.message);
                                            setLoader(false, "", false)
                                            setFailScreen(true, "Failed to open file", e.message, true)
                                            callback && callback()
                                        },
                                        success : function () {
                                            console.log('file opened successfully');
                                            setLoader(false, "", false)
                                            callback && callback()
                                        }
                                    }
                                );
                            // }
                        // }
                    // });
                },
                function(error) {
                    console.log("download error source " + error.source);
                    console.log("download error target " + error.target);
                    console.log("download error code" + error.code);
                    setLoader(false, "", false)
                    callback && callback()
                    setFailScreen(true, "Download failed", "We couldn't download the file, please check your internet connection and try again", true)
                },
                false
            );
    
        }, onErrorCreateFile);
    
    }, onErrorLoadFs);
    function onErrorCreateFile(err){
        callback && callback()
        setLoader(false, "", false)
        console.log(`Error while creating file: ${err}`)
        setFailScreen(true, "Download failed", "We couldn't download the file, please check your internet connection and try again", true)
    }
    
    function onErrorLoadFs(err){
        callback && callback()
        setLoader(false, "", false)
        console.log(`Error while loading file: ${err}`)
        setFailScreen(true, "Download failed", "We couldn't download the file, please check your internet connection and try again", true)
    }
}

export const clearSharedPref = (callback) => {

    console.log("clearsharedpref called")
    
    if (window.android) {
        window.android.clearedSharedPref();
        setTimeout(() => callback(), 3000)
    } else if (window.cordova && window.cordova.plugins && window.cordova.plugins.AssaAbloy) {
        window.cordova.plugins.AssaAbloy.terminateEndpoint(
            "hello",
            () => { console.log("terminateEndpoint success"); callback() },
            () => { console.log("terminateEndpoint failed"); callback() }
        );
    }
}


export function getCleanUrl(url) {

    if (!url || typeof url !== 'string') {
      return '';
    }
  
    if (url.startsWith('http')) {
      return url;
    }
    const cleanUrl = url.replace('../', '');
    return `${CMSPath}${cleanUrl}`;
  }

export const makeStringStrictlyCapitalize = (s)=>{
    if(typeof s !="string") return s;

    let words = s.split(" ")
    const updatedWords = words.map((word)=>{
        if(word=="") return word;
        return String(word[0]).toUpperCase() + String(word).slice(1).toLowerCase();
    });

    return updatedWords.join(" ");
 }


export function debounce(fn, timer){
    let timeout;

    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>{fn(...args)},timer)
    }
}
